import React from "react";

interface BlockSkeletonProps {
  lines?: number;
  className?: string;
}

const FleetrifyBlockSkeleton: React.FC<BlockSkeletonProps> = ({
  lines = 3,
  className = "",
}) => {
  return (
    <div
      className={`animate-pulse p-4 bg-gray-100 rounded-md space-y-3 ${className}`}
    >
      {Array.from({ length: lines }).map((_, idx) => (
        <div key={idx} className="h-4 bg-gray-300 rounded w-full" />
      ))}
    </div>
  );
};

export default FleetrifyBlockSkeleton;
